import { isolatePhrase, renderVariable } from "@climatepartner/utils";
import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";

import { formatLongDateOrPlaceholder } from "../../../../../shared/lib/format-date";

// Fallback label when the backend hasn't populated buyerName yet.
export const BUYER_NAME_FALLBACK = "A ClimatePartner buyer";

// Header rendered above the account-selection flow (Figma 1-8026). buyerName and respondBy are
// nullable on the backend DTO, so both are rendered defensively: buyerName falls back to a generic
// label and the "Respond by" line is omitted entirely when there is no deadline.
export const InvitationHeaderCard = ({
  buyerName,
  supplierName,
  respondBy,
}: {
  buyerName: string | null;
  supplierName: string;
  respondBy: string | null;
}): ReactElement => (
  <Box sx={{ borderRadius: 2, bgcolor: "background.paper", px: 2.5, py: 2.5, width: "100%" }}>
    <Typography
      variant="caption"
      sx={{ display: "block", textTransform: "uppercase", fontWeight: 600, letterSpacing: "0.8px", mb: 1 }}
    >
      Invitation
    </Typography>
    <Typography variant="h4">
      {isolatePhrase(
        <>
          <Box component="span" sx={{ fontWeight: 700 }}>
            {renderVariable(buyerName ?? BUYER_NAME_FALLBACK)}
          </Box>{" "}
          has invited{" "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            {renderVariable(supplierName)}
          </Box>{" "}
          to share Product Carbon Footprint (PCF) data.
        </>
      )}
    </Typography>
    {respondBy && (
      <Typography variant="body1" sx={{ mt: 1, color: "text.secondary" }}>
        {isolatePhrase(
          <>
            Respond by{" "}
            <Box component="span" sx={{ fontWeight: 500, color: "text.primary" }}>
              {renderVariable(formatLongDateOrPlaceholder(respondBy))}
            </Box>
          </>
        )}
      </Typography>
    )}
  </Box>
);
